import { useStore } from '@nanostores/react';
import { atom } from 'nanostores';

export const $pdf = atom<Uint8Array | null>(null);
export const $showPdf = atom(false);

export function PrintPane() {
  const pdf = useStore($pdf);
  const showPdf = useStore($showPdf);

  function openInNewTab() {
    if (!pdf) return;
    const blob = new Blob([pdf as BlobPart], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    window.open(url);
  }

  function printPdf() {
    if (!pdf) return;
    const blob = new Blob([pdf as BlobPart], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    const win = window.open(url, '_blank');
    win?.print();
  }

  if (!showPdf) return null;

  return (
    <div className="flex w-full grow flex-col items-center justify-center">
      <div className="relative w-full gap-2 bg-white p-2">
        <button
          className="mr-2 cursor-pointer rounded p-1 px-2 transition hover:bg-gray-100"
          onClick={openInNewTab}
        >
          Open in new tab
        </button>
        <button
          className="cursor-pointer rounded p-1 px-2 transition hover:bg-gray-100"
          onClick={printPdf}
        >
          Print
        </button>
        <button
          className="float-right cursor-pointer rounded p-1 px-2 transition hover:bg-gray-100"
          onClick={() => $showPdf.set(false)}
        >
          ×
        </button>
      </div>
      <div className="flex h-full w-full grow items-center justify-center">
        {pdf ? (
          <iframe
            className="h-full w-full"
            src={`data:application/pdf;base64,${pdf.toBase64()}`}
          />
        ) : (
          <span>No PDF loaded</span>
        )}
      </div>
    </div>
  );
}
